interface Props {
  emoji?: string;
  title: string;
  count: number;
  subtitle?: string;
  /** SC-730 : couleur de la categorie. Reprise sur le trait du titre et sur
   *  une pastille, pour que la section defilee porte le meme repere que la
   *  pastille et la tuile qui y menent. */
  color?: string;
  /** Carnet du serveur : le titre passe en bandeau bas, sans compteur. Le grand
   *  titre d'affiche coute 43 a 78 px par categorie (« Menus Maki Sushi »
   *  repasse a la ligne) — presque deux plats, sur une carte qu'on parcourt
   *  section par section toute la soiree. */
  compact?: boolean;
}

export default function SectionTitle({ emoji, title, count, subtitle, color, compact = false }: Props) {
  return (
    <div
      className={`flex items-end justify-between gap-3 border-b-2 border-ink ${
        compact ? 'pb-0.5 mb-1' : 'pb-1 mb-1 md:pb-1.5 md:mb-2'
      }`}
      style={color ? { borderColor: color } : undefined}
    >
      <div className="min-w-0">
        {/* La pastille reste en flux inline : passer le h2 en flex empecherait
            un nom de categorie long de revenir a la ligne. */}
        <h2
          className={`font-display text-ink leading-none m-0 ${
            compact
              ? 'text-[15px] uppercase tracking-[0.06em]'
              : 'text-[28px] md:text-[38px]'
          }`}
        >
          {color && (
            <span
              aria-hidden="true"
              className={`inline-block align-middle me-2 rounded-[4px] border border-ink/30 ${
                compact ? 'w-[11px] h-[11px]' : 'w-[14px] h-[14px] md:w-[18px] md:h-[18px]'
              }`}
              style={{ backgroundColor: color }}
            />
          )}
          {emoji && <span className="mr-2">{emoji}</span>}
          {title}
        </h2>
        {/* mb-0: preflight is disabled, so a bare <p> keeps the UA 1em bottom
            margin — it was adding ~13px of dead space under the header. */}
        {subtitle && (
          <p className="font-mono text-[13px] md:text-[15px] text-ink/55 mt-1 mb-0 leading-[1.35]">{subtitle}</p>
        )}
      </div>
      {!compact && (
        <span
          className="shrink-0 font-mono font-bold text-[11px] md:text-[13px] text-ink/55 uppercase tracking-[0.04em] bg-cream border-[1.5px] border-ink px-[7px] py-[5px] md:px-[10px] md:py-[6px]"
        >
          {count} {count === 1 ? 'produit' : 'produits'}
        </span>
      )}
    </div>
  );
}
